<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-3/4 h-3/4 mx-auto bg-white border rounded-lg"
  >
    <div @click="closeModal()" style="cursor: pointer;" class="absolute top-0 right-0 z-[100]">
      <svg
        width="24" height="24"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:ns1="http://sozi.baierouge.fr"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        id="svg2"
        viewBox="0 0 744.09 1052.4"
        version="1.1"
      >
        <g id="layer1">
          <path
            id="path2989"
            d="m814.29 606.65a314.29 314.29 0 1 1 -628.57 0 314.29 314.29 0 1 1 628.57 0z"
            stroke="#000"
            stroke-width="5"
            transform="matrix(1.1048 0 0 1.1048 -179.21 -162.53)"
          />
          <g
            id="g3763"
            transform="matrix(.91837 0 0 .91837 47.587 10.944)"
            stroke="#fff"
            stroke-linecap="round"
            stroke-width="133.87"
            fill="none"
          >
            <path
              id="path2991"
              d="m176.51 362.87 356.13 356.13"
            />
            <path
              id="path2993"
              d="m532.64 362.87-356.13 356.13"
            />
          </g>
        </g>
      </svg>
    </div>

    <person-linkage-root @personToAssociate="handleAssociation"> </person-linkage-root>
  </VueFinalModal>
</template>

<script setup>
  import PersonLinkageRoot from '@components/person_linkage_system/PersonLinkageRoot'
  import { onMounted, ref } from 'vue'
  import { VueFinalModal } from 'vue-final-modal'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  let selectedPerson = ref('')
  let resultCb = props.params.resultCb

  onMounted(() => {
  })


  function closeModal () {
    resultCb && resultCb(selectedPerson.value)
    emit('close')
  }

  function handleAssociation (person) {
    selectedPerson.value = person
    closeModal()
  }
</script>

<style>
  .vm--modal {
    overflow: initial !important;
  }
</style>
